import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const DaftarRoPage = lazy(() => import('./pages/daftar-ro'))
const DetailRoPage = lazy(() => import('./pages/detail-ro'))
const PengambilanNgPage = lazy(() => import('./pages/pengambilan-ng'))

/** Cluster C05 Return Order RM — RTN-01 (daftar-ro), RTN-02 (daftar-ro/:id), RTN-04 (pengambilan-ng). */
const returnOrderRmRoutes: RouteObject[] = [
  {
    path: 'return-order-rm',
    children: [
      {
        path: 'daftar-ro',
        children: [
          { index: true, element: <DaftarRoPage /> },
          { path: ':id', element: <DetailRoPage /> }
        ]
      },
      { path: 'pengambilan-ng', element: <PengambilanNgPage /> }
    ]
  }
]

export default returnOrderRmRoutes
